import { render, staticRenderFns } from "./solicitacoesAcessoInstituicao.vue?vue&type=template&id=453e6c38&"
import script from "./solicitacoesAcessoInstituicao.vue?vue&type=script&lang=js&"
export * from "./solicitacoesAcessoInstituicao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports